module.exports = __webpack_public_path__ + "img/defaultThumbnail.0f554152.png";